export var REGSITER_LEAD_RESPONSE = "REGSITER_LEAD_RESPONSE";
export var UPDATE_PARTNER_SELECTED_SLOT = "UPDATE_PARTNER_SELECTED_SLOT";
